__webpack_require__.p = "/wp-content/themes/tablinx/tablinx-chat/dist/";